export default __webpack_public_path__ + "static/media/03_box-2.01f8696e.jpg";